import { ParsedUrlQuery } from 'querystring';

export function getIncludeRented(query: ParsedUrlQuery) {
    if (query['include_rented']) {
        return query['include_rented'];
    }

    return '';
}
